import React from 'react';
import { User } from 'firebase/auth';
import { useTranslation } from 'react-i18next';
import '../pages/BudgetRoute.css';
import LanguagePicker from './LanguagePicker';
import SettingsDropdown from './SettingsDropdown';
import { UserProfile } from './UserProfile';
import { isFeatureEnabled } from '../utils/featureFlags';
import { ActualServer } from '../types';

interface AppHeaderProps {
  user: User | null;
  activeServer: ActualServer | null;
  onShowAuthModal: (mode?: 'signin' | 'signup') => void;
  onManageServers: () => void;
  currentPage?: 'home' | 'budget' | 'pricing';
}

const AppHeader: React.FC<AppHeaderProps> = ({
  user,
  activeServer,
  onShowAuthModal,
  onManageServers,
  currentPage = 'home',
}) => {
  const { t } = useTranslation();

  return (
    <header className="App-header">
      <div className="header-top">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <nav className="budget-route-nav" aria-label="Main">
            <a
              href="/"
              className={`budget-route-header-link ${currentPage === 'home' ? 'active' : ''}`}
            >
              {t('app.title')}
            </a>
            <a
              href="/budget"
              className={`budget-route-header-link ${currentPage === 'budget' ? 'active' : ''}`}
            >
              {t('navLink', { ns: 'budget' })}
            </a>
          </nav>
          <LanguagePicker />
          <a
            href="/pricing"
            className={`pricing-button ${currentPage === 'pricing' ? 'active' : ''}`}
          >
            {isFeatureEnabled('ENABLE_PAYWALL') ? t('actions.pricing') : t('actions.betaPricing')}
          </a>

          {user ? (
            <>
              <SettingsDropdown
                activeServer={activeServer}
                onManageServers={onManageServers}
              />
              <UserProfile />
            </>
          ) : (
            <button
              className="user-profile-button"
              onClick={() => onShowAuthModal('signup')}
            >
              {t('signUp', { ns: 'auth' })}
            </button>
          )}
        </div>
      </div>
      <h1>{t('app.title')}</h1>
      <p>{t('app.subtitle')}</p>
    </header>
  );
};

export default AppHeader;
